import uiButton from '@/components/ui/uiButton'
import uiCard from '@/components/ui/uiCard'
import uiCardLayout from '@/components/ui/uiCardLayout'
import uiTag from '@/components/ui/uiTag'
import uiInput from '@/components/ui/uiInput'
import uiDateInput from '@/components/ui/uiDateInput'
import uiDevider from '@/components/ui/uiDevider'
import uiSwitch from '@/components/ui/uiSwitch'
import uiList from '@/components/ui/uiList'
import uiDropdown from '@/components/ui/uiDropdown'
import uiTextarea from '@/components/ui/uiTextarea'
import uiEditable from '@/components/ui/uiEditable'
import uiLoader from '@/components/ui/uiLoader'
import uiFold from '@/components/ui/uiFold'
import uiPreload from '@/components/ui/uiPreload'
import uiBlockTitle from '@/components/ui/uiBlockTitle'
import uiColorPicker from '@/components/ui/uiColorPicker'
import uiImage from '@/components/ui/uiImage'
import uiVideo from '@/components/ui/uiVideo'
import uiPdf from '@/components/ui/uiPdf'
// import uiScrollbar from '@/components/ui/uiScrollbar'
// import DraggerView from '@/components/DraggerView'

const install = Vue => {
  Vue.component('uiButton', uiButton)
  Vue.component('uiCard', uiCard)
  Vue.component('uiCardLayout', uiCardLayout)
  Vue.component('uiTag', uiTag)
  Vue.component('uiInput', uiInput)
  Vue.component('uiDateInput', uiDateInput)
  Vue.component('uiDevider', uiDevider)
  Vue.component('uiSwitch', uiSwitch)
  Vue.component('uiList', uiList)
  Vue.component('uiDropdown', uiDropdown)
  Vue.component('uiTextarea', uiTextarea)
  Vue.component('uiEditable', uiEditable)
  Vue.component('uiLoader', uiLoader)
  Vue.component('uiFold', uiFold)
  Vue.component('uiPreload', uiPreload)
  Vue.component('uiBlockTitle', uiBlockTitle)
  Vue.component('uiColorPicker', uiColorPicker)
  Vue.component('uiImage', uiImage)
  Vue.component('uiVideo', uiVideo)
  Vue.component('uiPdf', uiPdf)
  // Vue.component('uiScrollbar', uiScrollbar)
  // Vue.component('DraggerView', DraggerView)
}

export default { install }
